import { z } from "zod";

export const TaskStatus = {
  Pending: "Pending",
  Running: "Running",
  Completed: "Completed",
  Failed: "Failed",
  Cancelled: "Cancelled",
} as const;

export const TaskStatusSchema = z.enum(TaskStatus);

export const TaskSchema = z.strictObject({
  id: z.string().min(1),
  status: TaskStatusSchema,
  createdAt: z.iso.datetime({ offset: true }),
  startedAt: z.iso.datetime({ offset: true }).nullable(),
  completedAt: z.iso.datetime({ offset: true }).nullable(),
  isPublic: z.boolean(),
});

export const TasksSchema = z.array(TaskSchema);

export const TaskLogSchema = z.strictObject({
  id: z.string().min(1),
  taskId: z.string().min(1),
  executionId: z.string().min(1),
  timestamp: z.int(),
  level: z.enum(["Information", "Warning", "Error"]),
  message: z.string(),
  exception: z.string().nullish(),
});

export const TaskLogsSchema = z.array(TaskLogSchema);

export type Task = z.infer<typeof TaskSchema>;
export type TaskStatus = z.infer<typeof TaskStatusSchema>;
export type TaskLog = z.infer<typeof TaskLogSchema>;
